import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  ISSUER_RATESDETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';


const fetchIssuerRatesDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.ISSUER_RATE}/${gid}`);

export function* getIssuerRatesDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchIssuerRatesDetails, action.payload);
    yield put({ type: ISSUER_RATESDETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ISSUER_RATESDETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}
